// home-video.js — click-to-load players for the "From the shop floor" row.
//
// Nothing third-party is fetched until a visitor presses a card: the card
// ships as a still plate, and the press swaps that plate for a YouTube or
// Vimeo iframe, or for a <video> when the merchant pointed the block at a
// Shopify-hosted file. Pressing the same control again puts the plate back,
// which is also what Escape does.
//
// Delegated from the document so a Shopify theme-editor re-render of the
// section needs no re-initialisation, and guarded so two copies of the tag
// on one page cannot double-bind.
if (!window.__tmgVideoCards) {
  window.__tmgVideoCards = true;
  (function () {
    var YOUTUBE = /(?:youtube(?:-nocookie)?\.com\/(?:watch\?(?:[^#]*&)?v=|embed\/|shorts\/|live\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{6,64})/;
    var VIMEO = /vimeo\.com\/(?:video\/|channels\/[^/]+\/|groups\/[^/]+\/videos\/)?(\d{6,})/;
    var FILE = /\.(mp4|m4v|webm|ogv|ogg|mov)(?:[?#]|$)/i;

    // Returns what to build for a merchant-entered URL, or null when the URL
    // is empty or is not something we can embed (a page about a video, say).
    // The iframe src is assembled from a matched id, never from the raw
    // string, so a hostile "url" cannot become a javascript: source.
    function playerFor(url) {
      var u = (url || '').trim();
      if (!u) return null;
      var m = u.match(YOUTUBE);
      if (m) {
        return {
          kind: 'iframe',
          src: 'https://www.youtube-nocookie.com/embed/' + m[1] +
            '?autoplay=1&rel=0&playsinline=1&modestbranding=1'
        };
      }
      m = u.match(VIMEO);
      if (m) {
        return {
          kind: 'iframe',
          src: 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1&byline=0&portrait=0'
        };
      }
      if (FILE.test(u) && /^(https?:)?\/\//.test(u)) return { kind: 'video', src: u };
      return null;
    }

    function open(card, btn) {
      var media = card.querySelector('[data-video-media]');
      var spec = playerFor(btn.getAttribute('data-video-url'));
      if (!media || !spec) return;

      var node;
      if (spec.kind === 'video') {
        node = document.createElement('video');
        node.setAttribute('controls', '');
        node.setAttribute('playsinline', '');
        node.setAttribute('preload', 'metadata');
        node.autoplay = true;
        node.src = spec.src;
      } else {
        node = document.createElement('iframe');
        node.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share');
        node.setAttribute('allowfullscreen', '');
        node.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        node.setAttribute('title', btn.getAttribute('data-video-title') || 'Video');
        node.src = spec.src;
      }
      node.className = 'video-player';
      media.appendChild(node);

      card.classList.add('is-playing');
      btn.setAttribute('aria-expanded', 'true');
      if (node.focus) node.focus({ preventScroll: true });
    }

    function close(card, btn, refocus) {
      var player = card.querySelector('.video-player');
      if (player) {
        // Drop the src first: a detached iframe can otherwise keep playing
        // audio in some browsers until it is garbage-collected.
        player.removeAttribute('src');
        player.remove();
      }
      card.classList.remove('is-playing');
      if (btn) {
        btn.setAttribute('aria-expanded', 'false');
        if (refocus) btn.focus({ preventScroll: true });
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-video-trigger]') : null;
      if (!btn) return;
      var card = btn.closest('.video-card');
      if (!card) return;
      e.preventDefault();
      if (card.classList.contains('is-playing')) close(card, btn, true);
      else open(card, btn);
    });

    // Escape returns the plate. It cannot fire while focus sits inside a
    // cross-origin player frame — that keystroke belongs to YouTube — so the
    // title button stays the reliable way back out.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      var open_ = document.querySelector('.video-card.is-playing');
      if (!open_) return;
      close(open_, open_.querySelector('[data-video-trigger]'), true);
    });

    // ---- the 375 rail ----
    // At phone widths the row becomes a horizontal scroller. A card that has
    // a video link is a tab stop and focusing it scrolls it into place, but a
    // card with no link carries no control at all, so on its own the rail can
    // hide content a keyboard cannot reach. Whenever the rail actually
    // overflows, it is made focusable and arrow-scrollable as well; at any
    // width where nothing is hidden the attributes come straight back off, so
    // the desktop row gains no focus stop. The name is the row's own heading
    // rather than a string in here, which keeps it in the merchant's language.
    function syncRails() {
      var rails = document.querySelectorAll('.video-grid');
      Array.prototype.forEach.call(rails, function (rail) {
        if (rail.scrollWidth - rail.clientWidth <= 1) {
          rail.removeAttribute('tabindex');
          rail.removeAttribute('role');
          rail.removeAttribute('aria-label');
          return;
        }
        rail.setAttribute('tabindex', '0');
        var sec = rail.closest ? rail.closest('.video-sec') : null;
        var h2 = sec ? sec.querySelector('h2') : null;
        var name = h2 ? h2.textContent.trim() : '';
        if (name) {
          rail.setAttribute('role', 'group');
          rail.setAttribute('aria-label', name);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncRails);
    } else {
      syncRails();
    }
    window.addEventListener('resize', syncRails);
    document.addEventListener('shopify:section:load', syncRails);

    // A theme-editor re-render replaces the markup wholesale; make sure no
    // orphaned player is left believing it is still open.
    document.addEventListener('shopify:section:unload', function (e) {
      var cards = e.target ? e.target.querySelectorAll('.video-card.is-playing') : [];
      Array.prototype.forEach.call(cards, function (c) {
        close(c, c.querySelector('[data-video-trigger]'), false);
      });
    });
  })();
}
